import React, { useState } from 'react';
import { useAuth } from '../Services/AuthContext';
import { useIntl } from 'react-intl';
import './Register.scss';

const Register = () => {
    const { register } = useAuth();
    const intl = useIntl();
    const t = (id) => intl.formatMessage({ id });
    const [form, setForm] = useState({ username: '', email: '', password: '' });
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = async e => {
        e.preventDefault();
        setError('');
        setMessage('');
        const res = await register(form);
        if (res.success) {
            setMessage(t('register_success'));
        } else {
            setError(t(res.errorId || 'register_failed'));
        }
    };

    return (
        <div className="register-page">
            <h1>{t('register_heading')}</h1>
            <p>{t('register_intro')}</p>
            <form onSubmit={handleSubmit}>
                <input
                    type="text"
                    placeholder={t('username_placeholder')}
                    required
                    value={form.username}
                    onChange={e => setForm({ ...form, username: e.target.value })}
                />
                <input
                    type="email"
                    placeholder={t('email_placeholder')}
                    required
                    value={form.email}
                    onChange={e => setForm({ ...form, email: e.target.value })}
                />
                <input
                    type="password"
                    placeholder={t('password_placeholder')}
                    required
                    value={form.password}
                    onChange={e => setForm({ ...form, password: e.target.value })}
                />
                <button type="submit">{t('register')}</button>
                {message && <p className="success-msg">{message}</p>}
                {error && <p className="error-msg">{error}</p>}

            </form>
        </div>
    );
};
export default Register;